import React from 'react';

import CaseStudy from '../case-study';

function StoryblokCaseStudyComponent(data) {
  return <CaseStudy {...data} />;
}

export default StoryblokCaseStudyComponent;
